import { useSelector } from 'react-redux';
import {
    getPreviewCreatorLevel,
    getPreviewLocationId,
} from '../../../../../../selectors';

export const useCreatorLevel = () => useSelector(getPreviewCreatorLevel);
export const useLocationId = () => useSelector(getPreviewLocationId);
